import ArticlesHero from './ArticlesHero';

export default ArticlesHero;
